var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item md-size-60"},[_c('tour-list')],1),_c('div',{staticClass:"md-layout-item md-size-40"},[_c('tour-management')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }